import React from 'react';

import classNames from 'classnames';
import {ErrorField} from 'components/Fields';
import AsyncSelect from 'components/AsyncSelect';

import './styles.css';

const AsyncSelectField = ({
  input: {onBlur, onChange, value},
  className,
  meta: {touched, error},
  disabled,
  placeholder,
  creatable,
  buildOptions,
  fetchFunction,
  promptTextCreator,
  arrowRenderer,
  valueRenderer,
  optionRenderer,
  onClear,
  onNewOptionClick,
  valueKey,
  labelKey,
  filterOptions,
  showDropdownWhenEmpty = false
}: any) => {
  return (
    <div className={classNames('AsyncSelectField', className)}>
      <AsyncSelect
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        valueKey={valueKey}
        labelKey={labelKey}
        placeholder={placeholder}
        creatable={creatable}
        buildOptions={buildOptions}
        fetchFunction={fetchFunction}
        promptTextCreator={promptTextCreator}
        arrowRenderer={arrowRenderer}
        optionRenderer={optionRenderer}
        valueRenderer={valueRenderer}
        onNewOptionClick={onNewOptionClick}
        onClear={onClear}
        filterOptions={filterOptions}
        showDropdownWhenEmpty={showDropdownWhenEmpty}
      />
      <ErrorField touched={touched} error={error} />
    </div>
  );
};

export default AsyncSelectField;
